import script from "./recuperar-senha.vue?vue&type=script&setup=true&lang=js"
export * from "./recuperar-senha.vue?vue&type=script&setup=true&lang=js"

import "./recuperar-senha.vue?vue&type=style&index=0&id=9920711a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9920711a"]])

export default __exports__